import React, {ChangeEvent, useEffect, useRef, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import * as Yup from "yup";
import {initialPage, PageContent, PageModel, TagType} from "../Post-List/core/_model";
import {useFormik} from "formik";
import {
    ID,
    initialQueryState,
    isNotEmpty,
    KTCard,
    KTCardBody,
    KTSVG,
    toAbsoluteUrl
} from "../../../../_metronic/helpers";
import {createPost, getPostById, updatePost} from "../Post-List/core/_requests";
import {SwalClose, SwalConferm, SwalError, SwalLoading} from "../../../../_metronic/helpers/components/Swal";
import clsx from "clsx";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import DatePicker, {DateObject} from "react-multi-date-picker";
import './style.css'
import {PostType} from "../../Post/Post-List/core/_model";
import ContentChild from "./ContentChild";
import Swal from "sweetalert2";
import { Modal} from "react-bootstrap";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import  Editor from '@ckeditor/customEditor/build/ckeditor';
import {QueryResponseProvider} from "../../Elemnt/PostCategory_list/core/QueryResponseProvider";
import {ListViewProvider, useListView} from "../../Elemnt/PostCategory_list/core/ListViewProvider";
import {QueryRequestProvider, useQueryRequest} from "../../Elemnt/PostCategory_list/core/QueryRequestProvider";
import ElementModalSelect from "./ElementModalSelect";
import {getUserById} from "../../Elemnt/PostCategory_list/core/_requests";
import {ElementModel} from "../../Elemnt/PostCategory_list/core/_models";


const API_URL = process.env.REACT_APP_API_URL
const urlFileManager = process.env.REACT_APP_URL_FILE_MANAGER ;
const urlFiles = process.env.REACT_APP_URL_FILES ;

const editPostSchema = Yup.object().shape({
    title: Yup.string()
        .min(2, ` حدااقل ${3} کاراکتر مورد تایید میباشد`)
        .max(150, ` حداکثر ${150} کاراکتر مورد تایید میباشد`)
        .required('عنوان پست اجاری میباشد'),
    url: Yup.string()
        .min(2, ` حدااقل ${3} کاراکتر مورد تایید میباشد`)
        .max(2048, ` حداکثر ${2048} کاراکتر مورد تایید میباشد`)
        .required('لینک پست اجاری میباشد'),
    description: Yup.string()
        .min(2, ` حدااقل ${70} کاراکتر مورد تایید میباشد`)
        .max(255, ` حداکثر ${255} کاراکتر مورد تایید میباشد`)
        .required('توضیحات اجباری میباشد'),
    content: Yup.string(),

    keys: Yup.string()
        .min(1, ` حدااقل ${1} کاراکتر مورد تایید میباشد`)
        .max(255, ` حداکثر ${255} کاراکتر مورد تایید میباشد`),


})

const PagePost = () => {
    const inputFile = useRef(null);
    const [preview, setPreview] = useState('')
    const [file, setFile] = useState<File>();
    const [keyInputValue, setKeyValue] = useState<string>('')
    const [postContent, setPostContent] = useState<PageContent[]>([])
    const [keys, setKeys] = useState<string[]>([])
    const {id} = useParams();
    const [Post, setPost] = useState<PageModel>();
    const navigator = useNavigate();
    const [loading, setLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [url, setUrl] = useState('') ;
    const [showModalElement , setShowModalElement] = useState(false)
    const [showModalText , setShowModalText] = useState(false)
    const [textSelected,detTextSelected] = useState('')
    const [textIsEdit,setTextIsEdit] = useState(false)
    const [ElementSelected,setElementSelected] = useState<ElementModel>()
    const {updateState} = useQueryRequest()
    useEffect(() => {
        if (!file) {
            setPreview('')
            return
        }
        const objectUrl = URL.createObjectURL(file)
        setPreview(objectUrl)

        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl)
    }, [file])
    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
        }
    };
    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            // 👇 Get input value
            AddKey();
        }
    };
    const AddKey = () => {
        const keyss = keys;
        keyss.push(keyInputValue);
        setKeys(keyss);
        setKeyValue('');
    }
    const RemoveKey = (e:number)=>{
        const keyss = [...keys];
        keyss.splice(e,1);
        setKeys(keyss)
    }
    const [PostForEdit] = useState<PageModel>({
        postType: Post?.postType || initialPage.postType,
        title: Post?.title || initialPage.title,
        description: Post?.description || initialPage.description,
        content: Post?.content || initialPage.content,
        keys: Post?.keys || initialPage.keys,
        picName: Post?.picName || initialPage.picName,
        dateTime: Post?.dateTime || initialPage.dateTime,
        dateString: Post?.dateString || initialPage.dateString,
        userID: Post?.userID || initialPage.userID,
        url: Post?.url || initialPage.url
    })
    const [indexSelect,setIndexSelect] = useState<{ index : number | undefined,ChildIndex : number | undefined}>()
    const formik = useFormik({
        initialValues: PostForEdit,
        validationSchema: editPostSchema,

        onSubmit: async (values, {setSubmitting}) => {
            let img: any = null;
            let formValue: PageModel = {
                id: 0,
                title: formik.values.title,
                content: formik.values.content,
                keys: keys.join(','),
                postType: formik.values.postType,
                description: formik.values.description,
                dateString: selectedDate ? selectedDate : Date.now().toString(),
                url,
                shortDescription: formik.values.shortDescription,
                picName: formik.values.picName,
                dateTime: formik.values.dateTime,


            };
            if (file) {
                img = file
            }
            if (id !== undefined) {

                formValue.id = Number(id);

                const update = async () => {
                    try {
                        SwalLoading()
                        setLoading(true)
                        await updatePost(formValue, url, img)
                        SwalClose()
                        setLoading(false)
                        navigator('/apps/Page/List')

                    } catch (err: any) {
                        console.log(err)
                        SwalClose()
                        setLoading(false)
                        SwalError(err.message! ||err.response?.data?.message )
                        // SwalError(err.response?.data?.message)
                    }

                }
                update()
            } else {
                const create = async () => {
                    try {
                        SwalLoading()
                        setLoading(true)
                        await createPost(formValue, url, img)
                        SwalClose()
                        setLoading(false)
                        navigator('/apps/Page/List')

                    } catch (err: any) {
                        SwalClose()
                        setLoading(false)
                        console.log(err)

                        SwalError(err.response?.data?.message)
                    }

                }
                create()
            }


        },

    });
    const titleChangehh = () => {
        const title = formik.values.title;
        if (title != null && id === undefined) {
            const value = encodeURIComponent(title)
            formik.setFieldValue('url', value)
            setUrl(value)
        }

    }
    const urlChange = (e) => {
        const title = e.target.value;
        if (title != null) {
            const value = encodeURIComponent(title)
            formik.setFieldValue('url', value)

            setUrl(value)
        }
    }
    useEffect(() => {
        const getUser = async () => {
            try {
                SwalLoading()
                const {data: post} = await getPostById(id);
                setPost(post)
                setPostContent(post!.pageContent! )
                setSelectedDate(post!.dateString! )
                setKeys(post.keys?.split(',') || [])
                setUrl(post.url || '')
                await formik.setFieldValue('url', post.url);
                await formik.setFieldValue('content', post.content);
                await formik.setFieldValue('title', post.title);
                await formik.setFieldValue('description', post.description);
                await formik.setFieldValue('postType', post.postType);
                await formik.setFieldValue('picName', post.picName);

                SwalClose()
            } catch (err: any) {
                SwalClose()
                SwalError(err?.response?.data?.message)
            }
        }

        if (isNotEmpty(id)) {
            getUser()
        }
    }, [])
    const AddGrid = (e : number)=>{
        const grid : PageContent =
            {
                tagType : TagType.Row,
                child :[]
            }
         ;
        switch (e){
            case 1 : {
                for (let i = 0; i < 12; i++) {
                    grid.child?.push({
                        tagType : TagType.Col_1
                    })
                }
                break
            }
            case 2 : {
                for (let i = 0; i < 4; i++) {
                    grid.child?.push({
                        tagType : TagType.Col_3
                    })
                }
                break
            }
            case 3 : {
                for (let i = 0; i < 3; i++) {
                    grid.child?.push({
                        tagType : TagType.Col_4
                    })
                }
                break
            }
            case 4 : {
                grid.child?.push({
                    tagType : TagType.Col_8
                })
                grid.child?.push({
                    tagType : TagType.Col_4
                })
                break
            }
            case 5 : {
                grid.child?.push({
                    tagType : TagType.Col_4
                })
                grid.child?.push({
                    tagType : TagType.Col_8
                })
                break
            }
            case 6 : {
                grid.child?.push({
                    tagType : TagType.Col_12
                })

                break
            }
        }




        let content =  [...postContent] ;
        if(indexSelect === undefined )
            setPostContent([...postContent, grid]);
        if(indexSelect !== undefined && indexSelect.index !== undefined){
            content.splice(indexSelect.index, 0, grid);
            setPostContent(content)
        }

    }
    useEffect(() => {
         formik.setFieldValue('content',JSON.stringify(postContent) );

    }, [postContent]);
    const removeRow = (e:number)=>{

        SwalConferm('آیا از حذف این ردیف اطمینان دارید ؟').then((res)=>{
            if(res.isConfirmed){
                const updatedRows = [...postContent];
                updatedRows.splice(e, 1);
                setPostContent(updatedRows);


            }
        })
    }
    const addGrid =async (e:number)=>{


        const { value: color } = await Swal.fire({
            title: 'عنوان مورد نظر خود را انتخاب نمایید ',
            input: 'radio',
            showCancelButton : true,
            cancelButtonText : 'لغو',
            inputOptions: {
                'grid': 'grid',
                'html': 'Text',
                'element': 'الگو'
            },
            confirmButtonText : 'تایید',
            inputValidator: (value) => {
                if (!value) {


                    return 'لطفا یکی از گزینه ها را انتخاب کنید !'
                }
            }
        })

        if (color) {
            setIndexSelect({index : e , ChildIndex : undefined});
            switch (color){
                case 'grid':{

                    // @ts-ignore
                    document.getElementById('GridClick').click()
                    break ;
                }
                case 'html':{
                    setShowModalText(true)
                    break ;
                }
                case 'element':{
                    setShowModalElement(true)
                    break ;
                }
            }

        }
    }
    const rowUp = (e:number)=>{
        const updatedRows = [...postContent];
        const element = updatedRows[e];
        updatedRows.splice(e, 1);
        updatedRows.splice(e -1 , 0, element);
        setPostContent(updatedRows)

    }
    const rowDown = (e:number)=>{
        const updatedRows = [...postContent];
        const element = updatedRows[e];
        updatedRows.splice(e, 1);
        updatedRows.splice(e +1 , 0, element);
        setPostContent(updatedRows)
    }
    const showElementModal = ()=>setShowModalElement(true);
    const showTextModal = ()=>setShowModalText(true);
    const TextAdd = ()=>{
        setShowModalText(false)
        const grid : PageContent =
            {
                tagType : TagType.HtmlContent,
                content : textSelected,
            } ;
        let content =  [...postContent] ;

        if(indexSelect === undefined)
            setPostContent([...postContent, grid]);
        if(indexSelect !== undefined && indexSelect.index !== undefined && indexSelect.ChildIndex === undefined){
            if(!textIsEdit)
                content.splice(indexSelect.index, 0, grid);
            else
                content.splice(indexSelect.index, 1, grid);

            setPostContent(content)
        }
        if(indexSelect !== undefined && indexSelect.index !== undefined && indexSelect.ChildIndex !== undefined){
            content[indexSelect.index]!.child![indexSelect.ChildIndex].child=  [grid]
            setPostContent(content)
        }
        detTextSelected('')
        setTextIsEdit(false)
        setIndexSelect(undefined)

    }
    const addContToChild =async (index:number , childIndex : number) =>{


        const { value: color } = await Swal.fire({
            title: 'عنوان مورد نظر خود را انتخاب نمایید ',
            input: 'radio',
            showCancelButton : true,
            cancelButtonText : 'لغو',
            inputOptions: {
                'html': 'Text',
                'element': 'الگو'
            },
            confirmButtonText : 'تایید',
            inputValidator: (value) => {
                if (!value) {


                    return 'لطفا یکی از گزینه ها را انتخاب کنید !'
                }
            }
        });
        if (color) {

            switch (color){
                case 'html':{
                    detTextSelected('')
                    setIndexSelect({index : index,ChildIndex: childIndex});
                    setShowModalText(true)
                    break ;
                }
                case 'element':{
                    setIndexSelect({index : index,ChildIndex: childIndex});
                    setShowModalElement(true)
                    break ;
                }
            }

        }


    }
    const editContToChild = (index:number , childIndex : number | undefined)=>{
        let content = '';
        if(index !==undefined && childIndex !== undefined){
            content = postContent[index]!.child![childIndex].child![0].content!  ;
        }
        if(index !==undefined && childIndex === undefined){
            content = postContent[index]!.content!  ;
        }
        detTextSelected(content);
        setIndexSelect({index : index,ChildIndex: childIndex});
        setShowModalText(true)
        setTextIsEdit(true)

    }
    const onAddElement =async (ID:ID)=>{
        if(ID != null){
            setShowModalElement(false)
            const element =await getUserById(ID)
            const grid : PageContent =
                {
                    tagType : TagType.Section,
                    sectionId :element!.id as number,
                    sectionTitle : element!.title ,
                    sectionImg : element!.picName
                } ;
            let content =  [...postContent] ;


            if(indexSelect === undefined)
                setPostContent([...postContent, grid]);
            if(indexSelect !== undefined && indexSelect.index !== undefined && indexSelect.ChildIndex === undefined){
                if(!textIsEdit)
                    content.splice(indexSelect.index, 0, grid);
                else
                    content.splice(indexSelect.index, 1, grid);

                setPostContent(content)
            }
            if(indexSelect !== undefined && indexSelect.index !== undefined && indexSelect.ChildIndex !== undefined){
                content[indexSelect.index]!.child![indexSelect.ChildIndex].child=  [grid]
                setPostContent(content)
            }

            setElementSelected(undefined)
            setIndexSelect(undefined)
            setTextIsEdit(false)
            setShowModalElement(false)

        }

    }
    const onEditElement =async (index : number , childIndex : number| undefined)=>{

        let ID :ID;
        if(index !==undefined && childIndex !== undefined){
            ID = postContent[index]!.child![childIndex].child![0].sectionId!  ;
        }
        if(index !==undefined && childIndex === undefined){
            ID = postContent[index]!.sectionId!  ;
        }
        const element =await getUserById(ID)
        if(element){
            // onSelect(ID)
            updateState({search: ID!.toString(), ...initialQueryState})

            setIndexSelect({index : index,ChildIndex: childIndex});
            setTextIsEdit(true)
            setShowModalElement(true)
        }

    }



    return (
        <>
            <KTCard>
                <form onSubmit={formik.handleSubmit} noValidate className='form'>
                    <div className="card-header">
                        <div className='card-title m-0'>
                            <h3 className='fw-bold m-0'>{isNotEmpty(id) === true ? 'ویرایش صفحه' : 'صفحه جدید'}</h3>
                        </div>
                        <div className=" align-self-center">
                            <button onClick={() => navigator('/apps/Post/List')} className="btn btn-light m-1">
                                لغو
                            </button>
                            <button type="submit" className="btn btn-primary ">
                                ذخیره
                            </button>
                        </div>

                    </div>
                    <KTCardBody className='py-4'>
                        <div className="row">
                            <div className="col-9">
                                {/* begin::Input group */}
                                <div className='fv-row mb-7'>
                                    {/* begin::Label */}
                                    <label className='required fw-semibold fs-6 mb-2'>لینک </label>
                                    {/* end::Label */}

                                    {/* begin::Input */}

                                    <input
                                        placeholder='لینک پست'
                                        type='text'
                                        name='url'
                                        onChange={urlChange}
                                        value={url}
                                        className={clsx(
                                            'form-control form-control-solid mb-3 mb-lg-0',
                                            {'is-invalid': formik.touched.url && formik.errors.url},
                                            {
                                                'is-valid': formik.touched.url && !formik.errors.url,
                                            }
                                        )}
                                        autoComplete='off'
                                        disabled={formik.isSubmitting || loading}
                                    />
                                    {formik.touched.url && formik.errors.url && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>
                                                <span role='alert'>{formik.errors.url}</span>
                                            </div>
                                        </div>
                                    )}
                                    {/* end::Input */}
                                </div>
                                {/* end::Input group */}
                                {/* begin::Input group */}
                                <div className='fv-row mb-7'>
                                    {/* begin::Label */}
                                    <label className='required fw-semibold fs-6 mb-2'>عنوان </label>
                                    {/* end::Label */}

                                    {/* begin::Input */}

                                    <input
                                        placeholder='عنوان '
                                        {...formik.getFieldProps('title')}
                                        type='text'
                                        name='title'
                                        // onChange={titleChange}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            titleChangehh()
                                        }}
                                        className={clsx(
                                            'form-control form-control-solid mb-3 mb-lg-0',
                                            {'is-invalid': formik.touched.title && formik.errors.title},
                                            {
                                                'is-valid': formik.touched.title && !formik.errors.title,
                                            }
                                        )}
                                        autoComplete='off'
                                        disabled={formik.isSubmitting || loading}
                                    />
                                    {formik.touched.title && formik.errors.title && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>
                                                <span role='alert'>{formik.errors.title}</span>
                                            </div>
                                        </div>
                                    )}
                                    {/* end::Input */}
                                </div>
                                {/* end::Input group */}
                                {/* begin::Input group */}
                                <div className='fv-row mb-7'>
                                    {/* begin::Label */}
                                    <label className='required fw-semibold fs-6 mb-2'>توضیحات </label>
                                    {/* end::Label */}

                                    {/* begin::Input */}

                                    <textarea
                                        placeholder='توضیحات '
                                        {...formik.getFieldProps('description')}

                                        name='description'
                                        className={clsx(
                                            'form-control form-control-solid mb-3 mb-lg-0',
                                            {'is-invalid': formik.touched.description && formik.errors.description},
                                            {
                                                'is-valid': formik.touched.description && !formik.errors.description,
                                            }
                                        )}
                                        autoComplete='off'
                                        disabled={formik.isSubmitting || loading}
                                    />
                                    {formik.touched.description && formik.errors.description && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>
                                                <span role='alert'>{formik.errors.description}</span>
                                            </div>
                                        </div>
                                    )}
                                    {/* end::Input */}
                                </div>
                                {/* end::Input group */}
                                {/* begin::Input group */}
                                <div className='fv-row mb-7'>
                                    {/* begin::Label */}
                                    <label className='required fw-semibold fs-6 mb-2'>متن پست</label>
                                    {/* end::Label */}

                                    {/* begin::Input */}
                                    <div className="ContentToolbar">
                                        <div className="py-5">
                                            <div className="rounded border p-5">

                                                <button
                                                    type="button"
                                                    id={"GridClick"}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#kt_modal_Grid"
                                                    className="btn btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary me-2 mb-2">Grid</button>
                                                <button
                                                    onClick={showElementModal}
                                                    type="button"
                                                    className="btn btn-outline btn-outline-dashed btn-outline-success btn-active-light-success me-2 mb-2">المان</button>
                                                <button
                                                    onClick={showTextModal}
                                                    type="button"
                                                    className="btn btn-outline btn-outline-dashed btn-outline-info btn-active-light-info me-2 mb-2">Text</button>


                                            </div>
                                        </div>
                                    </div>
                                    <div className="pageContent">
                                        <div className="py-5">
                                            <div className="rounded border p-10">
                                                {postContent.map((item,index)=>(
                                                    <ContentChild onEditElement={onEditElement} editContToChild={editContToChild} key={`rrr"${index}`} data={item} index={index} removeRow={removeRow} addGrid={addGrid} rowUp={rowUp} rowDown={rowDown} addContToChild={addContToChild}/>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {formik.touched.content && formik.errors.content && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>
                                                <span role='alert'>{formik.errors.content}</span>
                                            </div>
                                        </div>
                                    )}
                                    {/* end::Input */}
                                </div>
                                {/* end::Input group */}
                            </div>
                            <div className="col-3">
                                {id !== undefined && (
                                    <>
                                        {/* begin::Input group */}
                                        <div className='fv-row mb-7'>
                                            {/* begin::Label */}
                                            <label className='required fw-semibold fs-6 mb-2'>تاریخ </label>
                                            {/* end::Label */}

                                            {/* begin::Input */}
                                            <DatePicker
                                                calendar={persian}
                                                style={{
                                                    height: "38px",
                                                    fontSize: '14px',
                                                    width: '100%',
                                                    backgroundColor: 'var(--kt-input-solid-bg)',
                                                    borderColor: 'var(--kt-input-solid-bg)',

                                                }}
                                                placeholder='__/__/____'
                                                containerStyle={{
                                                    width: "100%"
                                                }}
                                                onChange={(e: DateObject) => {
                                                    if (e) {
                                                        setSelectedDate(`${e.year}/${e.month.number}/${e.day}`)
                                                        formik.setFieldValue("dateString", `${e.year}/${e.month.number}/${e.day}`);
                                                    }


                                                }}
                                                value={selectedDate}
                                                calendarPosition={`left-start`}
                                                fixMainPosition={true}
                                                fixRelativePosition={true}
                                                locale={persian_fa}
                                                disabled={formik.isSubmitting || loading}

                                            />

                                            {formik.touched.dateString && formik.errors.dateString && (
                                                <div className='fv-plugins-message-container'>
                                                    <div className='fv-help-block'>
                                                        <span role='alert'>{formik.errors.dateString}</span>
                                                    </div>
                                                </div>
                                            )}
                                            {/* end::Input */}
                                        </div>
                                        {/* end::Input group */}
                                        <div className="separator my-10"></div>

                                    </>
                                )}

                                <label className=' fw-semibold fs-6 mb-2'>تصویر شاخص</label>
                                {id !== undefined || file === undefined ?
                                    <img className="card-img img-thumbnail" width="300px"
                                         alt={formik.values.title}
                                         src={formik.values.picName !== undefined && formik.values.picName !== null ?
                                             `${API_URL}/img/Page/250/${formik.values.picName}`
                                             :
                                             toAbsoluteUrl('/media/avatars/300-2.jpg')

                                         }/>
                                    :
                                    <img className="card-img img-thumbnail" width="300px" src={preview} alt='avatar'/>

                                }

                                <input
                                    type='file'
                                    accept="image/png,image/jpeg"
                                    name='file'
                                    ref={inputFile}
                                    className=' form-control form-control-lg form-control-solid'
                                    onChange={handleFileChange}
                                ></input>
                                <div className="separator my-10"></div>

                                <div className="fv-row mb-7">
                                    <label className='required fw-semibold fs-6 mb-2'>وضعیت </label>
                                    <div>
                                        <select
                                            {...formik.getFieldProps('postType')}
                                            name='postType'

                                            className={clsx(
                                                'form-control form-control-solid mb-3 mb-lg-0',
                                                {'is-invalid': formik.touched.postType && formik.errors.postType},
                                                {
                                                    'is-valid': formik.touched.postType && !formik.errors.postType,
                                                }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || loading}
                                        >
                                            {Object.keys(PostType).map((key, index) => {

                                                const kkk = Object.keys(PostType[key]);
                                                if (kkk.length > 0) {
                                                    return (
                                                        <option key={`optionType-${index}`}
                                                                value={key}>{(PostType[key])}</option>

                                                    )
                                                }
                                                return (null)
                                            })}
                                        </select>

                                    </div>
                                </div>

                                <div className="separator my-10"></div>

                                <div>
                                    <h4>کلیمات کلیدی :</h4>
                                    <div>
                                        {keys.map((key, index) => (
                                            <div key={'key-' + index} className="symbol symbol-50px p-1">

                                                <span className="badge badge-circle   start-0 top-100 fs-10 cursor-pointer" onClick={()=>RemoveKey(index)}><i className="fa-solid fa-trash"></i></span>

                                                <div className="symbol-label fs-7 fw-bold bg-success">{key}</div>
                                            </div>


                                        ))}
                                    </div>


                                    <div className="input-group mt-4">
                                        <input
                                            className="form-control"
                                            aria-label="Recipient's username"
                                            aria-describedby="basic-addon2"
                                            value={keyInputValue}
                                            onChange={(e) => {
                                                setKeyValue(e.target.value)
                                            }}
                                            onKeyDown={handleKeyDown}


                                        />
                                        <div className="input-group-append">
                                            <button className="btn btn-outline-secondary btn-primary"
                                                    type="button"
                                                    onClick={AddKey}
                                            >افزودن

                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="separator my-10"></div>


                            </div>
                        </div>
                    </KTCardBody>
                </form>


            </KTCard>

            <div className="modal fade" tabIndex={-1} id="kt_modal_Grid">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">افزودن Grid</h5>
                            <div
                                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div data-bs-dismiss="modal"
                                 aria-label="Close" className="grid m-3 cursor-pointer" data-value="1" onClick={()=>AddGrid(1)}>
                                <div className="row rounded  text-center">
                                    <div className="col-md-1 bg-gray-300 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-600 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-300 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-600 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-300 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-600 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-300 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-600 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-300 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-600 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-300 rounded p-3" data-value="1">col-1</div>
                                    <div className="col-md-1 bg-gray-600 rounded p-3" data-value="1">col-1</div>
                                </div>
                            </div>
                            <div data-bs-dismiss="modal"
                                 aria-label="Close" className="grid m-3 cursor-pointer" data-value="2" onClick={()=>AddGrid(2)}>
                                <div className="row rounded  text-center">
                                    <div className="col-md-3 bg-gray-300 rounded p-3" data-value="2">col-3</div>
                                    <div className="col-md-3 bg-gray-600 rounded p-3" data-value="2">col-3</div>
                                    <div className="col-md-3 bg-gray-300 rounded p-3" data-value="2">col-3</div>
                                    <div className="col-md-3 bg-gray-600 rounded p-3" data-value="2">col-3</div>

                                </div>
                            </div>
                            <div data-bs-dismiss="modal"
                                 aria-label="Close" className="grid m-3 cursor-pointer" data-value="3" onClick={()=>AddGrid(3)}>
                                <div className="row rounded  text-center">
                                    <div className="col-md-4 bg-gray-300 rounded p-3" data-value="3">col-4</div>
                                    <div className="col-md-4 bg-gray-600 rounded p-3" data-value="3">col-4</div>
                                    <div className="col-md-4 bg-gray-300 rounded p-3" data-value="3">col-4</div>

                                </div>
                            </div>
                            <div data-bs-dismiss="modal"
                                 aria-label="Close" className="grid m-3 cursor-pointer" data-value="4" onClick={()=>AddGrid(4)}>
                                <div className="row rounded  text-center">
                                    <div className="col-md-8 bg-gray-300 rounded p-3" data-value="4">col-8</div>
                                    <div className="col-md-4 bg-gray-600 rounded p-3" data-value="4">col-4</div>

                                </div>
                            </div>
                            <div data-bs-dismiss="modal"
                                 aria-label="Close" className="grid m-3 cursor-pointer" data-value="5" onClick={()=>AddGrid(5)}>
                                <div className="row rounded  text-center">
                                    <div className="col-md-4 bg-gray-300 rounded p-3" data-value="5">col-4</div>
                                    <div className="col-md-8 bg-gray-600 rounded p-3" data-value="5">col-8</div>


                                </div>
                            </div>
                            <div data-bs-dismiss="modal"
                                 aria-label="Close" className="grid m-3 cursor-pointer" data-value="5" onClick={()=>AddGrid(6)}>
                                <div className="row rounded  text-center">
                                    <div className="col-md-12 bg-gray-300 rounded p-3" data-value="5">col-4</div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal fade modal-xl"  variant="primary" show={showModalElement} >
                <Modal.Header>
                    <h5 className="modal-title">افزودن Element</h5>
                    <div
                        className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                        onClick={()=>setShowModalElement(false)}
                    >
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr061.svg"
                            className="svg-icon svg-icon-2x"
                        />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <QueryRequestProvider>
                        <QueryResponseProvider>
                            <ListViewProvider>
                                <ElementModalSelect onsubmit={onAddElement} />
                            </ListViewProvider>
                        </QueryResponseProvider>
                    </QueryRequestProvider>
                </Modal.Body>

            </Modal>
            <Modal className="modal fade modal-xl"  variant="primary" show={showModalText} >
                <Modal.Header>
                    <h5 className="modal-title">افزودن Element</h5>
                    <div
                        className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                        onClick={()=>setShowModalText(false)}
                    >
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr061.svg"
                            className="svg-icon svg-icon-2x"
                        />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <CKEditor
                        editor={Editor}
                        data={textSelected}
                        onChange={(e,editor)=>{detTextSelected(editor.getData())}}
                        config={{
                            // @ts-ignore
                            htmlSupport: {
                                allow: [
                                    {
                                        name: /.*/,
                                        attributes: true,
                                        classes: true,
                                        styles: true
                                    }
                                ]
                            },
                            Flmngr: {
                                urlFileManager: urlFileManager,
                                urlFiles: urlFiles
                            },

                        }}

                    />
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={TextAdd}>تایید</button>
                </Modal.Footer>

            </Modal>

        </>

    );
};

export default PagePost;
